import { ActivatedRouteSnapshot } from '@angular/router';

export const getParentPath = (childRoute: ActivatedRouteSnapshot): string => {
  return childRoute.parent.pathFromRoot
    .map((path) => (path.url.length ? path.url.map((x) => x.path).join('/') : undefined))
    .filter((x) => !!x)
    .join('/');
};
